import React from 'react';
import ReactMarkdown from 'react-markdown';

import { sanitizeHtml } from 'utils/htmlUtils';

import styles from './ExecutiveSummary.scss';

export const ExecutiveSummary = ({ candidateData }) => {
  const { summary, rcrmSummary } = candidateData || {};

  const showSummary = !!(summary || rcrmSummary);

  return (
    <div className={styles.executiveSummaryContainer}>
      {showSummary && (
        <>
          <h2>Executive summary</h2>
          {summary ? (
            <ReactMarkdown>{summary}</ReactMarkdown>
          ) : (
            <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(rcrmSummary) }} />
          )}
        </>
      )}
    </div>
  );
};
